export default {
  points: [],
};
